import { useMediaQuery } from "@mui/material";
import { FaFilter } from "react-icons/fa";
import { Cancel } from "../../assets";

interface ActiveFilter {
  label: string;
  value: string;
  onRemove: () => void;
}

interface ActiveFiltersProps {
  filters: ActiveFilter[];
}

const ActiveFilters = ({ filters }: ActiveFiltersProps) => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  if (!filters || filters.length === 0) return null;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: isMobile ? "8px 0px" : "12px 0px",
        marginBottom: "20px",
        gap: isMobile ? "6px" : "10px",
      }}
    >
      {/* Label */}
      <span
        style={{
          fontSize: isMobile ? "11px" : "12px",
          fontWeight: 700,
          color: "#0c1a58",
          marginLeft: "6px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          whiteSpace: "nowrap",
        }}
      >
        <FaFilter size={isMobile ? 9 : 10} />
        فیلترهای فعال:
      </span>

      {/* Filter chips */}
      {filters.map((filter, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "6px",
            padding: isMobile ? "2px 6px 2px 3px" : "3px 8px 3px 4px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            borderLeft: "3px solid #ca9602",
            boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
            cursor: "default",
          }}
        >
          <span
            style={{
              fontSize: isMobile ? "10px" : "11px",
              color: "#525151",
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                color: "#0c1a58",
                fontWeight: 700,
              }}
            >
              {filter.label}:
            </span>{" "}
            {filter.value}
          </span>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "1px",
              borderRadius: "3px",
              transition: "background-color 0.15s",
            }}
            onClick={filter.onRemove}
            onMouseEnter={(e: React.MouseEvent<HTMLSpanElement>) =>
              (e.currentTarget.style.backgroundColor = "#f4563210")
            }
            onMouseLeave={(e: React.MouseEvent<HTMLSpanElement>) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <Cancel
              width={isMobile ? "10" : "12"}
              height={isMobile ? "10" : "12"}
              color="#f45632"
            />
          </span>
        </div>
      ))}
    </div>
  );
};

export default ActiveFilters;
